module.exports = __webpack_public_path__ + "static/media/img-web-resa@2x.f22dc833.png";